module.exports = __webpack_public_path__ + "static/media/ODD.7ed39436.png";